import { apiClient } from './client';
import type { Role } from '../types/api.types';

export interface CreateInvitationResponse {
  invitation: {
    token: string;
    tenantId: string;
    roles: Role[];
    email?: string;
    expiresAt: number;
  };
  link: string;
}

export const createInvitation = async (data: {
  roles: Role[];
  email?: string;
  expiresInDays?: number;
}): Promise<CreateInvitationResponse> =>
  (await apiClient.post('/api/invitations', data)).data;

/** Datos públicos de una invitación — se consultan sin sesión (F0.10). */
export interface InvitationInfo {
  tenantId: string;
  roles: Role[];
  email?: string;
}

export const getInvitation = async (token: string): Promise<InvitationInfo> =>
  (await apiClient.get(`/api/invitations/${encodeURIComponent(token)}`)).data;

export interface AcceptInvitationResponse {
  token?: string;
  /** OTP obligatorio en la empresa: el código ya salió por Telegram, no hay sesión aún. */
  requiresOtp?: boolean;
  needsRoleSelection: boolean;
  user: {
    phoneNumber?: string;
    name: string;
    roles: Role[];
    tenantId?: string;
  };
}

/**
 * Canjea la invitación creando la cuenta. Público: el invitado todavía no
 * tiene sesión, por eso `/api/invitations/*` está exento de tenant en
 * `client.ts`.
 */
export const acceptInvitation = async (
  token: string,
  // El teléfono es opcional: se puede entrar con Google o con correo y contraseña (sin Telegram).
  data: { name: string; phoneNumber?: string; email?: string; password?: string; idToken?: string },
): Promise<AcceptInvitationResponse> =>
  (await apiClient.post(`/api/invitations/${encodeURIComponent(token)}/accept`, data)).data;

/** Task 12 — genera (o regenera) el código de auto-registro del tenant. */
export interface GenerateSelfRegisterCodeResponse {
  code: string;
  link: string;
}

export const generateSelfRegisterCode = async (): Promise<GenerateSelfRegisterCodeResponse> =>
  (await apiClient.post('/api/self-register-code')).data;

/** Código/link vigente sin regenerarlo — null si el tenant nunca generó uno. */
export interface GetSelfRegisterCodeResponse {
  code: string | null;
  link: string | null;
}

export const getSelfRegisterCode = async (): Promise<GetSelfRegisterCodeResponse> =>
  (await apiClient.get('/api/self-register-code')).data;
